// 앱 공용 값 포맷터 모음(특정 도메인에 속하지 않는 일반 포맷). 도메인 전용 포맷은 각
// 도메인 formatters 에 둔다. 여기에는 재사용하는 원자 포맷만 둔다.

// 선택 입력의 양끝 공백을 제거한다. 내용이 없으면 API optional 값인 null 로 바꾼다.
export function normalizeOptionalText(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}

// 검색 입력처럼 단어 사이 공백의 개수에 의미가 없는 문자열을 정규화한다. 대소문자 정책은
// 도메인마다 다르므로 호출부가 명시적으로 적용한다.
export function normalizeWhitespace(value: string): string {
  return value.trim().replace(/\s+/g, " ");
}

// 숫자를 브라우저 로캘 천단위 구분으로 표시한다. 유한수가 아니면(NaN/Infinity) "-".
export function formatNumber(value: number): string {
  return Number.isFinite(value) ? new Intl.NumberFormat(undefined).format(value) : "-";
}

// 축약 단위 목록. 큰 단위부터 비교한다. step 카운트는 10억을 넘을 수 있으므로 B 까지 필요하다.
const COMPACT_UNITS: readonly (readonly [number, string])[] = [
  [1_000_000_000, "B"],
  [1_000_000, "M"],
  [1_000, "K"],
];

// 1000 이상 카운트를 K/M/B 접미사로 축약한다(소수 최대 `fractionDigits` 자리, 후행 0 제거).
// step 카운트처럼 자릿수가 큰 정수를 표시할 때 쓴다. 전체값은 호출부가 title 툴팁으로 함께 제공한다.
// 보조 줄처럼 폭이 좁은 곳은 자릿수를 줄여 호출한다(`157.3K`).
export function formatCompactCount(value: number, fractionDigits = 3): string {
  if (!Number.isFinite(value)) {
    return "-";
  }
  const abs = Math.abs(value);
  const unit = COMPACT_UNITS.find(([threshold]) => abs >= threshold);
  if (unit === undefined) {
    return String(value);
  }
  const [threshold, suffix] = unit;
  return `${(value / threshold).toFixed(fractionDigits).replace(/\.?0+$/, "")}${suffix}`;
}

// 수와 단위를 함께 적는다(예: `1 policy` / `2 policies`). 영어 화면 전용이다. 복수형이 규칙적이면
// plural 을 생략한다.
export function countLabel(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
